import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export enum AdminDialogSeverity{
  SUCCESS = "success",
  ERROR = "error",
  INFO = "info",
  WARNING = "warning",
}

type AdminDialogState = {
  openAdminDialog: boolean;
  adminDialogMessage: string;
  severity?: AdminDialogSeverity;
};

const initialState: AdminDialogState = {
  openAdminDialog: false,
  severity: AdminDialogSeverity.INFO,
  adminDialogMessage: "",
};

const adminDialogSlice = createSlice({
  name: "adminDialog",
  initialState: initialState,
  reducers: {
    handleOpenDialog: (state, action: PayloadAction<AdminDialogState>) => {
      state.openAdminDialog = true;
      state.adminDialogMessage = action.payload.adminDialogMessage;
      if(action.payload.severity){
        state.severity=action.payload.severity
      }
    },
    handleCloseDialog: (state) => {
      state.openAdminDialog = false;
      state.adminDialogMessage = "";
      state.severity=AdminDialogSeverity.INFO
    },
  },
});

export const { handleOpenDialog, handleCloseDialog } = adminDialogSlice.actions;
export default adminDialogSlice.reducer;